module.exports = __webpack_public_path__ + "static/media/prop-3@2x.f99cdf50.webp";